import { render, staticRenderFns } from "./ResourceView.vue?vue&type=template&id=6d6d3d31&"
import script from "./ResourceView.vue?vue&type=script&lang=js&"
export * from "./ResourceView.vue?vue&type=script&lang=js&"
import style0 from "./ResourceView.vue?vue&type=style&index=0&id=6d6d3d31&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports